var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V6H0V0H18ZM2 2H16V4H2V2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8V18H10V8H18ZM12 10H16V16H12V10Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H8V10H0V8Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H0V14H8V12Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16H8V18H0V16Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.2d24bb720945c04ecc186551c6a318cb.svg";
export { ForwardRef as ReactComponent };